import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { TableContainer, Paper, TextField, Button } from "@mui/material";
import { Typography } from "@mui/material";

// material-ui
import Box from "@mui/material/Box";
import TableHeader from "../../../../components/Tables/TableHeader";
import { Link } from "react-router-dom";
import { StaffuseAuth } from "../../../../security/StaffuseAuth";
import SimpleTableHeader from "../../../../components/Tables/SimpleTableHeader";
import TableHeaderAdv from "../../../../components/Tables/TableHeaderAdv";
import { Update_To_MongoDB_Push_To_Array_By_ID } from "../../../../api/Update_To_MongoDB_Push_To_Array_By_ID";
import { Update_To_MongoDB_By_ID } from "../../../../api/Update_To_MongoDB_By_ID";
import SimpleTableCell from "../../../../components/Tables/SimpleTableCell";
import { Update_To_MongoDB_By_ID_No_Alert } from "../../../../api/Update_To_MongoDB_By_ID_No_Alert";

function TableComponent({ Registers, setRegisters }) {
  const { logout } = StaffuseAuth();

  //----------------------------------Nested Sorting--------------------------------------------
  // State to track sort field and direction
  const [sortConfig, setSortConfig] = useState({
    field: "",
    direction: "",
    nest: "",
  });

  let sortedRegisters = React.useMemo(() => {
    let sortableItems = [...Registers];
    if (
      sortConfig.field === "" &&
      sortConfig.direction === "" &&
      sortConfig.nest === ""
    ) {
      sortableItems.sort((a, b) => {
        if (a.SEFInfo?.SEFSubmissionDate > b.SEFInfo?.SEFSubmissionDate) {
          return 1;
        } else if (
          a.SEFInfo?.SEFSubmissionDate <= b.SEFInfo?.SEFSubmissionDate
        ) {
          return -1;
        } else {
          return 0;
        }
      });
    } else if (sortConfig.field === "_id") {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.field] < b[sortConfig.field]) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (a[sortConfig.field] > b[sortConfig.field]) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    } else if (sortConfig.field !== null && sortConfig.field !== "") {
      sortableItems.sort((a, b) => {
        const aValue = a[sortConfig.nest]?.[sortConfig.field] ?? "";
        const bValue = b[sortConfig.nest]?.[sortConfig.field] ?? "";
        if (aValue.toLowerCase() < bValue.toLowerCase()) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue.toLowerCase() > bValue.toLowerCase()) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [Registers, sortConfig]);

  const requestSortAdv = (field, nest) => {
    let direction = "ascending";
    if (sortConfig.field === field && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ field, direction, nest });
  };

  //Override Times
  const [Status, setStatus] = useState(false);
  function handleAllowAllTimes(e, Register) {
    e.preventDefault();
    Update_To_MongoDB_By_ID(
      { "SummerArrivalDeparture.Allow_All_Times": "Yes" },
      "Registers_2025",
      "All",
      setStatus,
      Register._id,
      logout
    );
    //find this Register in the Registers array and update it with the new value
    const updatedRegisters = Registers.map((reg) => {
      if (reg._id === Register._id) {
        return {
          ...reg,
          SummerArrivalDeparture: {
            ...reg.SummerArrivalDeparture,
            Allow_All_Times: "Yes",
          },
        };
      }
      return reg;
    });
    setRegisters(updatedRegisters);
  }

  //Diasable Override TImes
  function handleDisableAllTimes(e, Register) {
    e.preventDefault();
    Update_To_MongoDB_By_ID(
      { "SummerArrivalDeparture.Allow_All_Times": "No" },
      "Registers_2025",
      "All",
      setStatus,
      Register._id,
      logout
    );

    //find this Register in the Registers array and update it with the new value
    const updatedRegisters = Registers.map((reg) => {
      if (reg._id === Register._id) {
        return {
          ...reg,
          SummerArrivalDeparture: {
            ...reg.SummerArrivalDeparture,
            Allow_All_Times: "No",
          },
        };
      }
      return reg;
    });
    setRegisters(updatedRegisters);
  }

  //----------------------------Actions
  ///////////////////////////////////////////////////
  //Where the boxes are made and the buttons are operated
  function handleUpdateProgress(e, Attendee, Value) {
    e.preventDefault();
    const newAttendee = { ...Attendee };
    newAttendee.SummerArrivalDeparture = {
      ...newAttendee.SummerArrivalDeparture,
      Progress: Value,
    };
    const updatedRegisters = Registers.map((reg) => {
      if (reg._id === Attendee._id) {
        return {
          ...reg,
          SummerArrivalDeparture: {
            ...reg.SummerArrivalDeparture,
            Progress: Value,
          },
        };
      }
      return reg;
    });
    setRegisters(updatedRegisters);
    Update_To_MongoDB_By_ID_No_Alert(
      { "SummerArrivalDeparture.Progress": Value },
      "Registers_2025",
      "All",
      Attendee._id,
      logout
    );
  }

  function handleMarkAllAsComplete(e) {
    Registers.forEach((Attendee) => {
      handleUpdateProgress(e, Attendee, "Complete");
    });
  }

  function handleUpdateType_Of_Departure(e, Attendee, Value) {
    e.preventDefault();
    const newAttendee = { ...Attendee };
    newAttendee.SummerArrivalDeparture = {
      ...newAttendee.SummerArrivalDeparture,
      Type_Of_Departure: Value,
    };
    const updatedRegisters = Registers.map((reg) => {
      if (reg._id === Attendee._id) {
        return {
          ...reg,
          SummerArrivalDeparture: {
            ...reg.SummerArrivalDeparture,
            Type_Of_Departure: Value,
          },
        };
      }
      return reg;
    });
    setRegisters(updatedRegisters);
  }

  function handleTypeType_Of_Departure(e, Attendee) {
    e.preventDefault();
    const newAttendee = { ...Attendee };
    newAttendee.SummerArrivalDeparture = {
      ...newAttendee.SummerArrivalDeparture,
      Type_Of_Departure: e.target.value,
    };
    const updatedRegisters = Registers.map((reg) => {
      if (reg._id === Attendee._id) {
        return {
          ...reg,
          SummerArrivalDeparture: {
            ...reg.SummerArrivalDeparture,
            Type_Of_Departure: e.target.value,
          },
        };
      }
      return reg;
    });
    setRegisters(updatedRegisters);
  }

  function handleUpdateTime_Of_Departure(e, Attendee, Value) {
    e.preventDefault();
    const newAttendee = { ...Attendee };
    newAttendee.SummerArrivalDeparture = {
      ...newAttendee.SummerArrivalDeparture,
      Time_Of_Departure: Value,
    };
    const updatedRegisters = Registers.map((reg) => {
      if (reg._id === Attendee._id) {
        return {
          ...reg,
          SummerArrivalDeparture: {
            ...reg.SummerArrivalDeparture,
            Time_Of_Departure: Value,
          },
        };
      }
      return reg;
    });

    setRegisters(updatedRegisters);
  }

  function handleTypeTime_Of_Departure(e, Attendee) {
    e.preventDefault();
    const newAttendee = { ...Attendee };
    newAttendee.SummerArrivalDeparture = {
      ...newAttendee.SummerArrivalDeparture,
      Time_Of_Departure: e.target.value,
    };
    const updatedRegisters = Registers.map((reg) => {
      if (reg._id === Attendee._id) {
        return {
          ...reg,
          SummerArrivalDeparture: {
            ...reg.SummerArrivalDeparture,
            Time_Of_Departure: e.target.value,
          },
        };
      }
      return reg;
    });
    setRegisters(updatedRegisters);
  }

  function handleStaffNotes(e, Attendee) {
    e.preventDefault();
    const newAttendee = { ...Attendee };
    newAttendee.SummerArrivalDeparture = {
      ...newAttendee.SummerArrivalDeparture,
      Travel_Notes_Staff: e.target.value,
    };
    const updatedRegisters = Registers.map((reg) => {
      if (reg._id === Attendee._id) {
        return {
          ...reg,
          SummerArrivalDeparture: {
            ...reg.SummerArrivalDeparture,
            Travel_Notes_Staff: e.target.value,
          },
        };
      }
      return reg;
    });
    setRegisters(updatedRegisters);
  }

  function handleSaveAll(e, Attendee) {
    e.preventDefault();
    Update_To_MongoDB_By_ID(
      {
        "SummerArrivalDeparture.Type_Of_Departure":
          Attendee.SummerArrivalDeparture?.Type_Of_Departure || "",
        "SummerArrivalDeparture.Time_Of_Departure":
          Attendee.SummerArrivalDeparture?.Time_Of_Departure || "",
        "SummerArrivalDeparture.Travel_Notes_Staff":
          Attendee.SummerArrivalDeparture?.Travel_Notes_Staff || "",
      },
      "Registers_2025",
      "All",
      setStatus,
      Attendee._id,
      logout
    );
  }
  //-----------------------------Return---------------------------------------------

  return (
    <Box
      component="main"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        maxWidth: "95%",
        maxHeight: "800px",
        flexGrow: 1,
        p: 1,
      }}
    >
      <Typography variant="h6" gutterBottom>
        View Register
        <button onClick={(e) => handleMarkAllAsComplete(e)}>
          Mark All As Complete
        </button>
      </Typography>
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          margin: "0 auto",
          overflow: "auto",
        }}
      >
        <Table
          aria-label="simple table"
          sx={{
            border: "1px solid #e0e0e0",
            tableLayout: "fixed",
          }}
        >
          <TableHead>
            <TableRow>
              {TableHeaderAdv(
                "Progress",
                requestSortAdv,
                "SummerArrivalDeparture",
                "Progress"
              )}
              {TableHeaderAdv(
                "Name",
                requestSortAdv,
                "First_Name",
                "BasicInfo"
              )}
              {TableHeaderAdv(
                "ProgrammeTitle",
                requestSortAdv,
                "ProgrammeTitle",
                "BasicInfo"
              )}
              {TableHeaderAdv(
                "ProgrammeDate",
                requestSortAdv,
                "ProgrammeDate",
                "BasicInfo"
              )}
              {SimpleTableHeader("Accom/ Airport")}
              {TableHeaderAdv(
                "ProgrammeVarient",
                requestSortAdv,
                "ProgrammeVarient",
                "BasicInfo"
              )}
              {SimpleTableHeader("View Attendee")}
              {TableHeaderAdv("SEF", requestSortAdv, "SEF", "SEFInfo")}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedRegisters.map((Register, index) => {
              const isArchived = Register?.MetaData?.Archived === "Yes";
              const programmeDate = Register.BasicInfo?.ProgrammeDate
                ? Register.BasicInfo?.ProgrammeDate ===
                  "(7th July - 18th July 2025)"
                  ? "Young 1"
                  : Register.BasicInfo?.ProgrammeDate ===
                    "(28th July - 8th August 2025)"
                  ? "Young 2"
                  : Register.BasicInfo?.ProgrammeDate ===
                    "(18th August - 29th August 2025)"
                  ? "Young 3"
                  : Register.BasicInfo?.ProgrammeDate
                : Register.BasicInfo?.ProgrammeDate;
              const isSummerProgramme =
                Register.BasicInfo?.ProgrammeTitle?.toLowerCase().includes(
                  "summer"
                );
              //
              const AirportCombination = (() => {
                const arrival =
                  Register.OrderInfo?.ProgrammeAirportArrival === "Yes";
                const departure =
                  Register.OrderInfo?.ProgrammeAirportDeparture === "Yes";
                const variantIncludesAirport =
                  Register.BasicInfo?.ProgrammeVarient?.toLowerCase().includes(
                    "airport"
                  );
                if (arrival && !departure) return "Airport_Arrival_Only";
                if (!arrival && departure) return "Airport_Departure_Only";
                if ((arrival && departure) || variantIncludesAirport)
                  return "Airport_Arrival_and_Departure";
                return "No_Airport_Transfers";
              })();
              //
              const ArrivalType = (() => {
                const arrival =
                  Register.OrderInfo?.ProgrammeAirportArrival === "Yes";
                const departure =
                  Register.OrderInfo?.ProgrammeAirportDeparture === "Yes";
                const variantIncludesAirport =
                  Register.BasicInfo?.ProgrammeVarient?.toLowerCase().includes(
                    "airport"
                  );
                if (arrival || (variantIncludesAirport && !departure))
                  return "Airport_Arrival";
                return "General_Arrival";
              })();
              //
              const Type_Of_Departure = (() => {
                const arrival =
                  Register.OrderInfo?.ProgrammeAirportArrival === "Yes";
                const departure =
                  Register.OrderInfo?.ProgrammeAirportDeparture === "Yes";
                const variantIncludesAirport =
                  Register.BasicInfo?.ProgrammeVarient?.toLowerCase().includes(
                    "airport"
                  );
                if (departure || (variantIncludesAirport && !arrival))
                  return "Airport_Departure";
                return "General_Departure";
              })();

              const suggestedCoachTime = (() => {
                const departureTime =
                  Register.SummerArrivalDeparture
                    ?.Departure_Airport_Departure_Time || "";
                if (departureTime === "") {
                  return "";
                } else if (departureTime > "19:00") {
                  return "15:00";
                } else if (departureTime > "18:00") {
                  return "14:00";
                } else if (departureTime > "16:00") {
                  return "12:00";
                } else if (departureTime > "14:00") {
                  return "10:00";
                } else if (departureTime > "12:00") {
                  return "08:00";
                } else {
                  return "";
                }
              })();

              return (
                <>
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor: isArchived ? "rgba(139, 0, 0, 0.5)" : "",
                      "&:hover": {
                        backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                        "& .MuiTableCell-root": {
                          padding: "8px",
                          wordWrap: "break-word",
                          overflowWrap: "break-word", // Adjust padding here to make cells smaller
                        },
                      },
                    }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                        backgroundColor: isArchived
                          ? "rgba(139, 0, 0, 0.5)"
                          : Register.SummerArrivalDeparture?.Progress ===
                            "Complete"
                          ? "#06862F"
                          : Register.SummerArrivalDeparture?.Progress ===
                            "Awaiting_Review"
                          ? "#F98007"
                          : Register.SummerArrivalDeparture?.Progress ===
                            "In_Progress"
                          ? "#0853B6"
                          : Register.SummerArrivalDeparture?.Progress ===
                            "Incomplete"
                          ? "#d11212"
                          : "",
                      }}
                    >
                      {Register.SummerArrivalDeparture?.Progress}
                    </TableCell>

                    {SimpleTableCell(
                      Register.BasicInfo?.First_Name +
                        " " +
                        Register.BasicInfo?.Last_Name
                    )}
                    {SimpleTableCell(Register.BasicInfo?.ProgrammeTitle)}
                    {SimpleTableCell(programmeDate)}
                    {SimpleTableCell(
                      (Register.BasicInfo?.ProgrammeVarient
                        ? Register.BasicInfo?.ProgrammeVarient.toLowerCase().includes(
                            "accom"
                          )
                          ? "Accom"
                          : "Non Accom"
                        : Register.BasicInfo.ProgrammeVarient) +
                        ", " +
                        AirportCombination.replaceAll("_", " ")
                    )}
                    {SimpleTableCell(Register.BasicInfo?.ProgrammeVarient)}

                    {/* New TableCell for update action using Link */}
                    <TableCell
                      align="left"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      <Link
                        to={`/Staff/ViewAttendee/${Register._id}`}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        <button style={{ width: "49%" }}>View</button>
                      </Link>
                      {Register.SummerArrivalDeparture?.Allow_All_Times ===
                      "Yes" ? (
                        <button
                          style={{ width: "49%", backgroundColor: "green" }}
                          onClick={(e) => handleDisableAllTimes(e, Register)}
                        >
                          Overriden Times{" "}
                        </button>
                      ) : (
                        <button
                          style={{ width: "49%" }}
                          onClick={(e) => handleAllowAllTimes(e, Register)}
                        >
                          Allow All Times
                        </button>
                      )}
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {isSummerProgramme ? (
                        <>
                          <Link
                            to={`/Staff/ViewSEFReview/${Register._id}`}
                            target="_blank"
                            style={{ textDecoration: "none", width: "49%" }}
                          >
                            <button
                              style={{
                                textDecoration: "none",
                                width: "49%",
                                backgroundColor: !Register.SEFInfo?.SEF
                                  ? "#d11212"
                                  : Register.SEFInfo?.SEF === "Incomplete"
                                  ? "#d11212"
                                  : Register.SEFInfo?.SEF === "In_Progress"
                                  ? "#0853b6"
                                  : Register.SEFInfo?.SEF === "Awaiting_Review"
                                  ? "#f98007"
                                  : Register.SEFInfo?.SEF === "Complete"
                                  ? "#06862f"
                                  : "",
                              }}
                            >
                              SEF{" "}
                              {Register.SEFInfo?.SEF
                                ? Register.SEFInfo?.SEF.replaceAll("_", " ")
                                : "Not Started"}
                            </button>
                          </Link>
                          <Link
                            to={`/Student/login/${Register._id}/${Register?.MetaData?.Password}`}
                            target="_blank"
                            style={{ textDecoration: "none", width: "49%" }}
                          >
                            <button
                              style={{
                                textDecoration: "none",
                                backgroundColor: "",
                                width: "49%",
                              }}
                            >
                              Open SEF
                            </button>
                          </Link>
                        </>
                      ) : (
                        <></>
                      )}
                    </TableCell>
                  </TableRow>

                  <TableRow
                    sx={{
                      backgroundColor: isArchived ? "rgba(139, 0, 0, 0.5)" : "",
                      "&:hover": {
                        backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                        "& .MuiTableCell-root": {
                          wordWrap: "break-word",
                          overflowWrap: "break-word", // Adjust padding here to make cells smaller
                        },
                      },
                    }}
                  >
                    <TableCell colSpan="2">
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "1.5em",
                          fontWeight: "bold",
                          textDecoration: "underline",
                        }}
                      >
                        {ArrivalType.replaceAll("_", " ")}
                      </div>
                      <br></br>
                      {Register?.SummerArrivalDeparture &&
                      typeof Register?.SummerArrivalDeparture === "object" ? (
                        Object.entries(Register?.SummerArrivalDeparture).map(
                          ([key, value]) => (
                            <>
                              {key.startsWith("Arrival") ? (
                                <div style={{ fontSize: "1.2em" }}>
                                  {key.replaceAll("_", " ")}: <b>{value}</b>
                                  <br></br>
                                </div>
                              ) : (
                                <></>
                              )}
                            </>
                          )
                        )
                      ) : (
                        <></>
                      )}
                    </TableCell>
                    <TableCell colSpan="2">
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "1.5em",
                          fontWeight: "bold",
                          textDecoration: "underline",
                        }}
                      >
                        {Type_Of_Departure.replaceAll("_", " ")}
                      </div>
                      <br></br>
                      {Register?.SummerArrivalDeparture &&
                      typeof Register?.SummerArrivalDeparture === "object" ? (
                        Object.entries(Register?.SummerArrivalDeparture).map(
                          ([key, value]) => (
                            <>
                              {key.startsWith("Departure") ? (
                                <div style={{ fontSize: "1.2em" }}>
                                  {key.replaceAll("_", " ")}: <b>{value}</b>
                                  <br></br>
                                </div>
                              ) : (
                                <></>
                              )}
                            </>
                          )
                        )
                      ) : (
                        <></>
                      )}
                    </TableCell>
                    <TableCell colSpan={2}>
                      {/* Departure Options */}
                      {AirportCombination === "Airport_Departure_Only" ||
                      AirportCombination === "Airport_Arrival_and_Departure" ? (
                        <>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <button
                              style={{}}
                              onClick={(e) =>
                                handleUpdateType_Of_Departure(
                                  e,
                                  Register,
                                  "Coach"
                                )
                              }
                            >
                              Coach
                            </button>
                            <button
                              style={{}}
                              onClick={(e) =>
                                handleUpdateType_Of_Departure(
                                  e,
                                  Register,
                                  "Taxi"
                                )
                              }
                            >
                              Taxi
                            </button>
                          </div>
                          <TextField
                            id="Type_Of_Departure"
                            variant="outlined"
                            value={
                              Register.SummerArrivalDeparture?.Type_Of_Departure
                            }
                            onChange={(e) =>
                              handleTypeType_Of_Departure(e, Register)
                            }
                            fullWidth
                            sx={{ mt: 2, my: "auto" }}
                          />
                          <br></br>
                          Accom Pick Up & Heathrow Drop Off :{" "}
                          {suggestedCoachTime !== ""
                            ? "Suggest " +
                                (suggestedCoachTime === ""
                                  ? "BAD TIMES"
                                  : suggestedCoachTime) +
                                " for " +
                                Register.SummerArrivalDeparture
                                  ?.Departure_Airport_Departure_Time || ""
                            : ""}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              flexWrap: "wrap",
                            }}
                          >
                            <button
                              style={{
                                backgroundColor:
                                  Register.SummerArrivalDeparture
                                    ?.Time_Of_Departure === "None"
                                    ? "green"
                                    : suggestedCoachTime === ""
                                    ? "darkblue"
                                    : "",
                                width: "50%",
                              }}
                              onClick={(e) =>
                                handleUpdateTime_Of_Departure(
                                  e,
                                  Register,
                                  "None"
                                )
                              }
                            >
                              None
                            </button>
                            <button
                              style={{
                                backgroundColor:
                                  Register.SummerArrivalDeparture
                                    ?.Time_Of_Departure === "08:00"
                                    ? "green"
                                    : suggestedCoachTime === "08:00"
                                    ? "darkblue"
                                    : "",
                                width: "50%",
                              }}
                              onClick={(e) =>
                                handleUpdateTime_Of_Departure(
                                  e,
                                  Register,
                                  "08:00"
                                )
                              }
                            >
                              08:00 / 09:00
                            </button>
                            <button
                              style={{
                                backgroundColor:
                                  Register.SummerArrivalDeparture
                                    ?.Time_Of_Departure === "10:00"
                                    ? "green"
                                    : suggestedCoachTime === "10:00"
                                    ? "darkblue"
                                    : "",
                                width: "50%",
                              }}
                              onClick={(e) =>
                                handleUpdateTime_Of_Departure(
                                  e,
                                  Register,
                                  "10:00"
                                )
                              }
                            >
                              10:00 / 11:00
                            </button>
                            <button
                              style={{
                                backgroundColor:
                                  Register.SummerArrivalDeparture
                                    ?.Time_Of_Departure === "12:00"
                                    ? "green"
                                    : suggestedCoachTime === "12:00"
                                    ? "darkblue"
                                    : "",
                                width: "50%",
                              }}
                              onClick={(e) =>
                                handleUpdateTime_Of_Departure(
                                  e,
                                  Register,
                                  "12:00"
                                )
                              }
                            >
                              12:00 / 13:00
                            </button>
                            <button
                              style={{
                                backgroundColor:
                                  Register.SummerArrivalDeparture
                                    ?.Time_Of_Departure === "14:00"
                                    ? "green"
                                    : suggestedCoachTime === "14:00"
                                    ? "darkblue"
                                    : "",
                                width: "50%",
                              }}
                              onClick={(e) =>
                                handleUpdateTime_Of_Departure(
                                  e,
                                  Register,
                                  "14:00"
                                )
                              }
                            >
                              14:00 / 15:00
                            </button>
                            <button
                              style={{
                                backgroundColor:
                                  Register.SummerArrivalDeparture
                                    ?.Time_Of_Departure === "15:00"
                                    ? "green"
                                    : suggestedCoachTime === "15:00"
                                    ? "darkblue"
                                    : "",
                                width: "50%",
                              }}
                              onClick={(e) =>
                                handleUpdateTime_Of_Departure(
                                  e,
                                  Register,
                                  "15:00"
                                )
                              }
                            >
                              15:00 / 16:00
                            </button>
                          </div>
                          Accom Pick Up:
                          <TextField
                            id="Time_Of_Departure"
                            variant="outlined"
                            value={
                              Register.SummerArrivalDeparture?.Time_Of_Departure
                            }
                            type={"time"}
                            onChange={(e) =>
                              handleTypeTime_Of_Departure(e, Register)
                            }
                            fullWidth
                            sx={{ mt: 2, my: "auto" }}
                          />
                        </>
                      ) : (
                        <></>
                      )}
                    </TableCell>
                    <TableCell>
                      <button onClick={(e) => handleSaveAll(e, Register)}>
                        Save Changes
                      </button>
                    </TableCell>
                    {/* Set Progress */}
                    <TableCell>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <button
                          style={{
                            backgroundColor: "#0853B6",
                          }}
                          onClick={(e) =>
                            handleUpdateProgress(e, Register, "In_Progress")
                          }
                        >
                          In Progress
                        </button>
                        <button
                          style={{
                            backgroundColor: "#F98007",
                          }}
                          onClick={(e) =>
                            handleUpdateProgress(e, Register, "Awaiting_Review")
                          }
                        >
                          Awaiting Review
                        </button>

                        {Type_Of_Departure !== "Airport_Departure" ||
                        (Register.SummerArrivalDeparture?.Type_Of_Departure &&
                          Register.SummerArrivalDeparture
                            ?.Time_Of_Departure) ? (
                          <button
                            style={{
                              backgroundColor: "#06862F",
                            }}
                            onClick={(e) =>
                              handleUpdateProgress(e, Register, "Complete")
                            }
                          >
                            Complete
                          </button>
                        ) : (
                          <></>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                  <TableRow
                    sx={{
                      backgroundColor: isArchived ? "rgba(139, 0, 0, 0.5)" : "",
                      "&:hover": {
                        backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                        "& .MuiTableCell-root": {
                          wordWrap: "break-word",
                          overflowWrap: "break-word", // Adjust padding here to make cells smaller
                        },
                      },
                    }}
                  >
                    <TableCell>Attendee Notes:</TableCell>
                    <TableCell colSpan="2">
                      {Register.SummerArrivalDeparture?.Travel_Notes}
                    </TableCell>
                    <TableCell>Staff Notes:</TableCell>
                    <TableCell colSpan="2">
                      <TextField
                        id="Travel_Notes_Staff"
                        variant="outlined"
                        value={
                          Register.SummerArrivalDeparture?.Travel_Notes_Staff
                        }
                        onChange={(e) => handleStaffNotes(e, Register)}
                        fullWidth
                        sx={{ mt: 2, my: "auto" }}
                      />
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow
                    sx={{
                      backgroundColor: isArchived
                        ? "rgba(139, 0, 0, 0.5)"
                        : "rgba(75, 75, 75, 0.8)",
                    }}
                  >
                    <TableCell colSpan={8}></TableCell>
                  </TableRow>
                </>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default TableComponent;
